import { typography } from '@shared/tokens/typography.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: palette['bronze-100'],
    width: '36px',
    minWidth: '36px',
    height: '36px',
    border: `1px solid ${colors.tertiaryBorder}`,
    borderRadius: anatomy.borderRadiusRound,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighDemi,
    textTransform: 'uppercase',
  },
});
